import Configuration from "./config"
import util from "./js/util"
import axios from "axios"
import { getClientFilterCodes } from "./js/credentialsApi.js"

let conf;

const NO_ACCESS = "__no_access__";

try {
    conf = Configuration.getConfiguration();
    console.log(conf);
} catch (error) {
    console.log(error);
}
const getHeaders = () => {
    try {
        const userDataRaw = sessionStorage.getItem('user');
        const token = sessionStorage.getItem('token');
        if (!userDataRaw) throw new Error('Usuario no autenticado.');
        if (!token) throw new Error('Token de autenticación no disponible.');
        const parsedUser = JSON.parse(userDataRaw);
        const destine = parsedUser?.destine;
        return {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
           
        };
    } catch (error) {
        console.error('Error al obtener headers:', error);
        return {};
    }
};

const serverConnection = (() => {


    let headers = { "Content-Type": "application/json;charset=UTF-8" }

    const login = async (username, password) => {
        let payload = { username, password }
        return axios.post(`${conf.API}/adminusers/login`, payload);
    };

    async function resolveClientCodes(params) {
        let data = {};
        try { data = JSON.parse(sessionStorage.getItem('user') || '{}'); } catch { }
        const role = Number(data?.rol ?? data?.role ?? null);
        if (role === -1) return;
        const allowed = await getClientFilterCodes();
        if (Array.isArray(allowed) && allowed.length) {
            params.clientCodes = allowed.join(',');
            return;
        }
        const clientId = data && (data.c_id ?? data.clientId ?? null);
        if (clientId !== undefined && clientId !== null && clientId !== '') {
            const asNumber = Number(clientId);
            params.clientId = Number.isNaN(asNumber) ? clientId : asNumber;
            return;
        }
        params.clientCodes = NO_ACCESS;
    }

    const client = {
        lists: async (params) => {
            const searchParams = new URLSearchParams(params);
            const searchValue = params.search?.trim() || params.searching?.trim();
            searchValue ? searchParams.set('search', searchValue) : searchParams.delete('search');
            const queryString = '?' + searchParams.toString();
            const headers = getHeaders();
            return axios.get(`${conf.ADMI_BO}/clients${queryString}`, { headers });
        },
        save: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.API}/clients`, payload, { headers });
        },
        remove: async (id) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.delete(`${conf.API}/clients/${id}`, { headers });
        },
        checkProviderCredential: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            params = util.serialize(params)
            return axios.get(`${conf.APIUSERS}/clients/checkProviderCredential?${params}`, { headers });
        },
        getClientCurrencies: async (clientCode) => {
             headers.Authorization = "Bearer " + sessionStorage.getItem("token");
             return axios.get(`${conf.ADMI_BO}/clients/${clientCode}/currencies`, { headers });
        },
        checkClientCredential: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            console.log("Checking client c redentials", payload);
            return axios.post(`${conf.API}/games/client/${payload.client_id}/provider/${payload.provider}/currency/${payload.currency}/checkCredentialsGames`, payload, { headers });
        },
        listCredentialsGames: async () => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/secrets`, { headers });
        },
        saveCredentials: async (payload, section) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            headers.section = section;
            return axios.post(`${conf.API}/secrets`, payload, { headers });
        },
        deleteCredentials: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            headers.section = payload.section;
            return axios.delete(`${conf.API}/secrets?secretName=${payload.keyId}`, { headers });
        },
        listCarrusels: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query = util.serialize(params)
            return axios.get(`${conf.ADMI_BO}/banners?${query}`, { headers });
        },
        saveCarrusel: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            // headers["Content-Type"] = "multipart/form-data";
            return axios.post(`${conf.ADMI_BO}/banners`, payload, { headers });
        },
        deleteCarrusel: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.delete(`${conf.ADMI_BO}/banners?${params}`, { headers });
        },
        listTopGames: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query = util.serialize(params);
            return axios.get(`${conf.API}/topGame?${query}`, { headers });
        },
        saveGamesPosition: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.API}/topGame`, payload, { headers });
        },
        listSections: async () => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/section`, { headers });

        },
        listTypes: async () => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/types`, { headers });
        },
        addType: async (type) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.API}/types`, type, { headers });
        },
        deleteTops: async (id) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.delete(`${conf.API}/topGame/${id}`, { headers });
        },
        obtainPresignedURL: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.ADMI_BO}/banners/presigned-url`,params,{ headers });
        },
        
    }

    const provider = {
        lists: async (params) => {
            const searchParams = new URLSearchParams(params);
            const headers = getHeaders();
            return axios.get(`${conf.ADMI_BO}/games/providers?${searchParams}`, { headers });
        },
        listByClient: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query = util.serialize(params)
            return axios.get(`${conf.API}/games/providers?${query}`, { headers });
        },
        listByClientByName: async (params) => {
            let clientName = params.clientName;
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/games/providers?clientName=${clientName}`, { headers });
        },
        listBrands: async (provider) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/games/providers/${provider}/brands`, { headers });
        },
        listGames: async (clientId, provider = null, brand = null) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query = `clientId=${clientId}`;
            if (provider) query = query + `&provider=${provider}`
            if (brand) query = query + `&brand=${brand}`
            return axios.get(`${conf.API}/games?${query}`, { headers });
        },
        removeBrands: async (payload) => {
            const headers = {
                Authorization: "Bearer " + sessionStorage.getItem("token"),
                'Content-Type': 'application/json'
            };
            let payload2 = {
                clienteid: payload.clientId,
                provider: payload.provider,
                action: payload.action,
                brands: payload.brands,
                category: payload.category,
                type: payload.type,
                original: payload.original,
                direct: payload.direct
            };
            if (!payload2.category) delete payload2.category;
            if (!payload2.type) delete payload2.type;
            if (!payload2.original) delete payload2.original;
            if (!payload2.direct) delete payload2.direct;
            return axios.post(`${conf.API}/games/client/${payload.clientId}/provider/${payload.provider}`, payload2, { headers });
        },

        addBrands: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let payload2 = {
                brands: payload.brands,
                action: payload.action,
                category: payload.category,
                type: payload.type,
                original: payload.original,
                direct: payload.direct
            }
            if (!payload2.category) delete payload2.category
            if (!payload2.type) delete payload2.type
            if (!payload2.original) delete payload2.original
            if (!payload2.direct) delete payload2.direct
            return axios.post(`${conf.API}/games/client/${payload.clientId}/provider/${payload.provider}`, payload2, { headers });
        },
        listBrandsWithoutClient: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query
            query = util.serialize(params)
            return axios.get(`${conf.API}/games/client?${query}`, { headers });
        },
    }

    const games = {
        list: async (params) => {
            let query = `?client=${params.clientCode}`;
            // search / searching
            const searchValue = params.search?.trim() || params.searching?.trim();
            if (searchValue) query += `&search=${searchValue}`;
            // Solo los tres que pediste
            if (params.provider) query += `&provider=${params.provider}`;
            if (params.brand) query += `&brand=${params.brand}`;
            if (params.category) query += `&category=${params.category}`;
            const headers = getHeaders();
            return axios.get(`${conf.ADMI_BO}/games/active${query}`, { headers });
        },



        listCategories: async (params) => {
            const headers = getHeaders();
            const query = new URLSearchParams(params);
            return axios.get(`${conf.ADMI_BO}/games/category?${query}`, { headers });
        },
        listTypes: async (category) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/games/${category}/types`, { headers });
        },
        listProvider: async () => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/games/providers`, { headers });
        },
        listBrands: async (provider) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/games/providers/${provider}/brands`, { headers });
        },
        listBrandsByClient: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query
            query = util.serialize(params)
            return axios.get(`${conf.ADMI_BO}/games/brands?${query}`, { headers });
        },
        listBrandsNotByClient: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query
            query = util.serialize(params)
            return axios.get(`${conf.API}/games/brandsNotByclient?${query}`, { headers });
        },
        saveGame: async (formData) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            headers["Content-Type"] = "multipart/form-data";
            return axios.post(`${conf.API}/games`, formData, { headers });
        },
        remove: async (id) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.delete(`${conf.API}/games/${id}`, { headers });
        },
        listGamesbyclient: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query
            query = util.serialize(params)
            return axios.get(`${conf.API}/games?${query}`, { headers });
        },
        listGamesWithoutClient: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query = `clientId=${params.clientId}`;
            if (params.provider) query = query + `&provider=${params.provider}`
            if (params.brand) query = query + `&brand=${params.brand}`
            if (params.search) query = query + `&search=${params.search}`
            return axios.get(`${conf.API}/games/notwithclient?${query}&page=${params.page}&xpage=${params.xpage}`, { headers });
        },

        removeGamesbyclient: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.delete(`${conf.API}/clients/${payload.clientId}/games/${payload.gameId}`, { headers });
        },
        addGametoClient: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.API}/clients/${payload.clientId}/games/${payload.gameId}`, payload, { headers });
        },
        listPragmaticFrbGames: async (clientCode, currency) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.GATEWAYAPI}/api/pragmatic/games`, {
                headers,
                params: { clientCode, currency }
            });
        },
        listPragmaticFreeChipGames: async (clientCode, currency) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.GATEWAYAPI}/api/pragmatic/casino_games`, {
                headers,
                params: { clientCode, currency }
            });
        },
    }

    const gamers = {
        list: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.API}/users?${params}`, { headers });
        },
        listv2: async (params) => {
            headers.Authorization = "Bearer " + "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJNZW5kb3phIiwiaWF0IjoxNzQxMTkzOTk1LCJleHAiOjE3NDEyMjk5OTV9.wC7BHfM4UUAKiGfDrFWRk7OlowkHSxTz04kbw4prXgo";
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.API_KS}/users?${params}`, { headers });
        },
        listUsers: async (params) => {
            try {
                if (params) { params = util.serialize(params) }
                let res = await axios.get(`${conf.API_KS}/users/externalUser?${params}`);
                console.log("Res", res);
            } catch (error) {
                console.log("Error 2", error);
            }


        }
    }

    const adminusers = {
        list: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.API}/adminusers?${params}`, { headers });
        },
        remove: async (id) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.delete(`${conf.API}/adminusers/${id}`, { headers });
        },
        save: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.API}/adminusers/register`, payload, { headers });
        },
        changePassword: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.API}/adminusers/change-password`, payload, { headers });
        }
    }

    const work = {
        list: async () => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/work/`, { headers });
        },
        listUsers: async () => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/work/users`, { headers });
        },
        listGroups: async () => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/work/groups`, { headers });
        },
        listItemsByGroup: async (groupId) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/work/itemsbygroup/${groupId}`, { headers });
        }

    }

    const freespin = {
        list: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.GATEWAYAPI}/freespins/?${params}`, { headers });
        },

        remove: async (id, provider) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.delete(`${conf.GATEWAYAPI}/freespins/${id}/${provider}`, { headers });
        },

        create: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.GATEWAYAPI}/freespins/`, payload, { headers });
        },
        authCampaign: async () => {
            let payload = {
                clientId: "ADMINBO",
                clientSecret: "123456"
            }
            return axios.get(`${conf.GATEWAYAPI}/auth`, payload);
        },
        listBonus: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.GATEWAYAPI}/bonus/search?${params}`);
        },
        createFreeSpinPrg: async (data) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            const pragmaticCreateFRB = util.serialize(data.pragmaticCreateFRB)
            const urlParams = new URLSearchParams(pragmaticCreateFRB).toString();
            const payload = {gameList: data.gameList};
            return axios.post(`${conf.GATEWAYAPI}/api/pragmatic/freespins/create?${urlParams}`, payload, { headers });
        },
        createFreeSpinPlayerPP: async (data) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            const pragmaticCreateFRB = util.serialize(data.pragmaticCreateFRB)
            const urlParams = new URLSearchParams(pragmaticCreateFRB).toString();
            const payload = {gameList: data.gameList, player: data.player};
            return axios.post(`${conf.GATEWAYAPI}/api/pragmatic/freespins/createPlayer?${urlParams}`, payload, { headers });
        },
        cancelFreeSpinPrg: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            const pragmaticCancelFRB = util.serialize(params)
            const urlParams = new URLSearchParams(pragmaticCancelFRB).toString();
            return axios.post(`${conf.GATEWAYAPI}/api/pragmatic/freespins/cancel?${urlParams}`, null, { headers });
        },
        listFreeSpinsPrg: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.GATEWAYAPI}/api/pragmatic/freespins/list?${params}`, { headers });
        },
        listFreeSpinsByUserPrg: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.post(`${conf.GATEWAYAPI}/api/pragmatic/freespins/getPlayers?${params}`, { headers });
        },
        deleteFreeSpinPrg: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let params = util.serialize(payload.params)
            return axios.post(`${conf.GATEWAYAPI}/api/pragmatic/freespins/removePlayer?${params}`, payload, { headers });
        },
        getBetScalesPrg: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.GATEWAYAPI}/api/pragmatic/freespins/getBetScales?${params}`, null, { headers });
        },
        addPlayersToCampaignPrg: async (params, payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            const query = util.serialize(params);
            return axios.post(`${conf.GATEWAYAPI}/api/pragmatic/freespins/addPlayers?${query}`, payload, { headers });
        },
        addPlayerToCampaignPrg: async (params, payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            const query = util.serialize(params);
            return axios.post(`${conf.GATEWAYAPI}/api/pragmatic/freespins/addPlayer?${query}`, payload, { headers });
        },
        getFreeChipValuesPrg: async (clientCode, payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            const query = new URLSearchParams({ clientCode: String(clientCode ?? "").trim() }).toString();
            return axios.post(`${conf.GATEWAYAPI}/api/pragmatic/freechips/getChipValues?${query}`, payload, { headers });
        },
        getFreeChipCurrencyMultipliersPrg: async (clientCode, payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            const query = new URLSearchParams({ clientCode: String(clientCode ?? "").trim() }).toString();
            return axios.post(`${conf.GATEWAYAPI}/api/pragmatic/freechips/getCurrencyMultipliers?${query}`, payload, { headers });
        },
        createFreeChipsPrg: async (params, payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            const query = new URLSearchParams(util.serialize(params)).toString();
            return axios.post(`${conf.GATEWAYAPI}/api/pragmatic/freechips/create?${query}`, payload, { headers });
        },
        cancelFreeChipsPrg: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            const query = new URLSearchParams(util.serialize(params)).toString();
            return axios.post(`${conf.GATEWAYAPI}/api/pragmatic/freechips/cancel?${query}`, {}, { headers });
        },
        addFreeChipPlayersPrg: async (params, payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            const query = new URLSearchParams(util.serialize(params)).toString();
            return axios.post(`${conf.GATEWAYAPI}/api/pragmatic/freechips/addPlayers?${query}`, payload, { headers });
        },
        addFreeChipPlayerPrg: async (params, payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            const query = new URLSearchParams(util.serialize(params)).toString();
            return axios.post(`${conf.GATEWAYAPI}/api/pragmatic/freechips/addPlayer?${query}`, payload, { headers });
        },
        removeFreeChipPlayersPrg: async (params, payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            const query = new URLSearchParams(util.serialize(params)).toString();
            return axios.post(`${conf.GATEWAYAPI}/api/pragmatic/freechips/removePlayers?${query}`, payload, { headers });
        },
        getFreeChipsByPlayerPrg: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            const query = new URLSearchParams(util.serialize(params)).toString();
            return axios.post(`${conf.GATEWAYAPI}/api/pragmatic/freechips/getPlayers?${query}`, {}, { headers });
        },
        listFreeSpinsPP: async (payload) => {
            return axios.post(`${conf.GATEWAYAPI}/api/pate-play/list`, payload, { headers });
        },
        createFreeSpinsPtp: async (payload) => {
            return axios.post(`${conf.GATEWAYAPI}/api/pate-play/create`, payload, { headers });
        },
        saveBonusCancelation: async (payload) => {
            return axios.post(`${conf.GATEWAYAPI}/api/pate-play/cancel`, payload, {});
        },
        stakeGeneratorSave: async (payload) => {
            return axios.post(`${conf.GATEWAYAPI}/api/pate-play/stakes`, payload, {});
        },
        getBonusById: async (bonusId) => {
            return axios.post(`${conf.GATEWAYAPI}/api/pate-play/bonus`, bonusId, {});
        },
        getProvidersNobus: async () => {

            const searchParams = new URLSearchParams({});
            const headers = getHeaders();
            return axios.get(`${conf.GATEWAYAPI}/api/novus-casino/free-rounds/providers`, { headers });
        },
        saveCampaignNovus: async (payload) => {
            if (payload.id) {
                return axios.put(`${conf.GATEWAYAPI}/api/novus-casino/free-rounds/${payload.id}`, payload);
            }
            return axios.post(`${conf.GATEWAYAPI}/api/novus-casino/free-rounds`, payload);
        },
        getCampaignNovus: async (params) => {
            if (params) { params = util.serialize(params); }
            return axios.get(`${conf.GATEWAYAPI}/api/novus-casino/free-rounds${params ? '?' + params : ''}`);
        },
        deleteCampaignById: async (id) => {
            return axios.delete(`${conf.GATEWAYAPI}/api/novus-casino/free-rounds/${id}`);
        },
        changeStatusCampaignById: async (id, status) => {
            return axios.put(`${conf.GATEWAYAPI}/api/novus-casino/free-rounds/${id}/status`, { is_enabled: status });
        },
        getPlayesByCampaing: async (params) => {

            return axios.get(`${conf.GATEWAYAPI}/api/novus-casino/free-rounds/${params.id}/players?page=${params.page}&limit=${params.limit}`, {});
        },

        getDetallByPlayerId: async (params) => {
            let url = `${conf.GATEWAYAPI}/api/novus-casino/free-rounds/${params.id}/players/${params.player_id}/details`;
            let queryParams = [];
            if (params.status) queryParams.push(`status=${params.status}`);
            if (params.start_date) queryParams.push(`start_date=${params.start_date}`);
            if (params.end_date) queryParams.push(`end_date=${params.end_date}`);
            if (queryParams.length > 0) {
                url += '?' + queryParams.join('&');
            }
            return axios.get(url, {});
        },
        removePlayerOffCampaign: async (params) => {

            return axios.delete(`${conf.GATEWAYAPI}/api/novus-casino/free-rounds/${params.id}/players/${params.player_id}`, {});
        },
        removeProductByBetAmountId: async (params) => {

            return axios.delete(`${conf.GATEWAYAPI}/api/novus-casino/free-rounds/${params.id}/products/${params.productId}`, {});
        },
        saveAddPlayerCampaign: async (playersId, campaignId) => {
            return axios.post(`${conf.GATEWAYAPI}/api/novus-casino/free-rounds/${campaignId}/players`, playersId);
        },
        saveAddGamesCampaign: async (games, campaignId) => {
            return axios.post(`${conf.GATEWAYAPI}/api/novus-casino/free-rounds/${campaignId}/products`, games);
        },
        saveBarbaraBang: async (campaign) => {
            return axios.post(`${conf.GATEWAYAPI}/api/barbara-bang/add-gift-spins`, campaign);
        },
        desactiveBarbaraBang: async (campaign) => {
            return axios.post(`${conf.GATEWAYAPI}/api/barbara-bang/deactivate`, campaign);
        },
        stakesBarBaraBang: async (campaign) => {
            return axios.post(`${conf.GATEWAYAPI}/api/barbara-bang/bet-ranges`, campaign);
        },
        getBarBaragBang: async (params) => {
            return axios.get(`${conf.GATEWAYAPI}/api/barbara-bang/list?code=${params.code}&provider=${params.provider}&brand=${params.brand}`, {});
        },
        getDetailByOfferId: async (params) => {

            return axios.get(`${conf.GATEWAYAPI}/api/barbara-bang/info?accountId=${params.accountId}&offerId=${params.offerId}`, {});
        },
        getCampaignById: async (id_for_fetch) => {
            return axios.get(`${conf.GATEWAYAPI}/api/novus-casino/free-rounds/${id_for_fetch}`, {});
        },

        //|||||      CAMPAIGN           ||||
        listCampaignByProviderIgp: async (provider, extraParams = {}) => {
            const params = { ...(extraParams || {}) };
            if (provider) params.provider = provider;
            await resolveClientCodes(params);
            return axios.get(`${conf.GATEWAYAPI}/api/campaignV2/list`, { params });
        },
        listCampaignByProvider: async (provider, extraParams = {}) => {
            const params = { ...(extraParams || {}) };
            if (provider) params.provider = provider;
            await resolveClientCodes(params);
            return axios.get(`${conf.GATEWAYAPI}/api/campaign/list`, { params });
        },
        getCampaignByCampaignIdIgp: async (campaignId) => {
            const res = await axios.get(`${conf.GATEWAYAPI}/api/campaignV2/${campaignId}`);
            const raw = res?.data;
            return Array.isArray(raw) ? raw[0] : raw;
        },
        getCampaignByCampaignId: async (campaignId) => {
            const res = await axios.get(`${conf.GATEWAYAPI}/api/campaign/${campaignId}`);
            const raw = res?.data;
            return Array.isArray(raw) ? raw[0] : raw;
        },
        createCampaign: async (params) => {
            return axios.post(`${conf.GATEWAYAPI}/api/campaign/createV2`, [params]);
        },
        createCampaignIgp: async (params) => {
            return axios.post(`${conf.GATEWAYAPI}/api/campaignV2/createV2`, [params], { headers });
        },
        updateStatusCampaignIgp: async (campaignId, status) => {
            return axios.patch(`${conf.GATEWAYAPI}/api/campaignV2/updateStatusCampaign/${campaignId}`, { status }, { headers });
        },
        updateStatusCampaign: async (campaignId, status) => {
            return axios.patch(`${conf.GATEWAYAPI}/api/campaign/updateStatusCampaign/${campaignId}`, { status });
        },
        updateStatusPlayer: async (bonusCode, status) => {
            return axios.patch(`${conf.GATEWAYAPI}/api/campaign/updateStatusPlayer/${encodeURIComponent(bonusCode)}`, { status });
        },
        addPlayerToCampaignIgp: async (campaignId, players) => {
            return axios.post(`${conf.GATEWAYAPI}/api/campaignV2/playersV2/add/${campaignId}`, players, { headers });
        },
        addPlayerToCampaign: async (campaignId, players) => {
            return axios.post(`${conf.GATEWAYAPI}/api/campaign/playersV2/add/${campaignId}`, players);
        },
        deletePlayerToCampaign: async (campaignId, playerId) => {
            return axios.post(`${conf.GATEWAYAPI}/api/campaign/players/remove/${campaignId}`, { playerId: String(playerId) });
        },
        //|||||      ENDORPHINA           ||||
        saveEndorphina: async (param) => {
            return axios.post(`${conf.GATEWAYAPI}/api/endorphin/free-rounds`, param)
        },
        getEndorphina: async (filters) => {
            const filteredParams = Object.fromEntries(
                Object.entries(filters).filter(([key, value]) => value !== '' && value != null)
            );
            return axios.get(`${conf.GATEWAYAPI}/api/endorphin/free-rounds`, { params: filteredParams });
        },
        deletEndorphina: async (params) => {
            const { id, nodeId } = params;
            return axios.delete(`${conf.GATEWAYAPI}/api/endorphin/free-rounds/${id}`, { params: { nodeId } });
        },

        // |||||      IGP           ||||
        saveIgp: async (payload) => {
            return axios.post(`${conf.GATEWAYAPI}/api/igp/promo/createV3`, payload, { headers });
        },
        deleteIgp: async (payload) => {
            return axios.post(`${conf.GATEWAYAPI}/api/igp/promo/cancel`, payload);
        },
        payloadTemporal: async (params) => {
            return axios.get(`${conf.GATEWAYAPI}/api/igp/promo/info`, params);
        },
        getBetScalesIgp: async (clientCode, gameId, currency) => {
            return axios.get(`${conf.GATEWAYAPI}/api/igp/promo/getBetScales`, {
                params: {
                    clientCode: clientCode,
                    gameId: gameId,
                    currency: currency
                }
            });
        },
        validateClientIgp: async (code) => {
            return axios.post(`${conf.GATEWAYAPI}/api/igp/promo/validateClient`, null, { params: { code } });
        },

        // |||||      AMIGOGAMING           ||||
        saveAmigoGaming: async (payload) => {
            return axios.post(`${conf.GATEWAYAPI}/api/agaming/bonus/player/createBatch`, payload);
        },
        deleteAmigoGaming: async (payload) => {
            return axios.post(`${conf.GATEWAYAPI}/api/agaming/bonus/cancel`, payload);
        },
        cancelPlayerAmigoGaming: async (campaignId, playerId) => {
            return axios.post(`${conf.GATEWAYAPI}/api/agaming/bonus/cancelPlayer/${encodeURIComponent(campaignId)}/${encodeURIComponent(playerId)}`);
        },
        getBetScalesAmigoGaming: async (payload) => {
            return axios.post(`${conf.GATEWAYAPI}/api/agaming/bonus/getBetScales`, payload);
        },
        validateClientAmigoGaming: async (code) => {
            return axios.post(`${conf.GATEWAYAPI}/api/agaming/bonus/validateClient`, null, { params: { code } });
        },

        // |||||      ANAKATECH FREE SPINS      ||||
        saveAnakatech: async (clientCode, currency, payload) => {
            return axios.post(`${conf.GATEWAYAPI}/api/anakatech/free-rounds`, payload, {
                params: { clientCode, currency }
            });
        },
        updateFreeRoundsBatchAnakatech: async (freeRoundId, clientCode, payload) => {
            return axios.put(
                `${conf.GATEWAYAPI}/api/anakatech/free-rounds/${encodeURIComponent(freeRoundId)}/bonus-batch`,
                payload,
                { params: { clientCode } }
            );
        },
        addPlayersToFreeRoundsAnakatech: async (freeRoundId, clientCode, payload) => {
            return axios.put(
                `${conf.GATEWAYAPI}/api/anakatech/free-rounds/add-player/${encodeURIComponent(freeRoundId)}`,
                payload,
                { params: { clientCode } }
            );
        },
        deleteAnakatech: async (campaignId) => {
            return axios.delete(`${conf.GATEWAYAPI}/api/anakatech/free-rounds/${campaignId}`);
        },
        getGameIdsAnakatech: async (clientCode, currency) => {
            return axios.get(`${conf.GATEWAYAPI}/api/anakatech/game-ids`, {
                params: { clientCode, currency }
            });
        },
        getBetOptionsByGameIdAnakatech: async (gameId, clientCode) => {
            return axios.get(`${conf.GATEWAYAPI}/api/anakatech/bet-options/${gameId}`, {
                params: { clientCode }
            });
        },
        getMultipliersPerIsoCodeAnakatech: async (currency) => {
            return axios.get(`${conf.GATEWAYAPI}/api/anakatech/currency-multipliers/${currency}`);
        },
        getFreeRoundsAnakatech: async (params) => {
            return axios.get(`${conf.GATEWAYAPI}/api/anakatech/free-rounds`, {params});
        },
        listFreeSpinsAnakatech: async (params) => {
            return axios.get(`${conf.GATEWAYAPI}/api/anakatech/free-spins`, { params });
        },
        deleteFreeSpinAnakatech: async (freeRoundCode) => {
            return axios.delete(`${conf.GATEWAYAPI}/api/anakatech/free-rounds/${freeRoundCode}`)
        },
        deletePlayerFreeSpinAnakatech: async (campaignId, playerId) => {
            return axios.delete(
                `${conf.GATEWAYAPI}/api/anakatech/free-rounds/${encodeURIComponent(campaignId)}/players/${encodeURIComponent(playerId)}`
            );
        },
        updateFreeSpinStatusAnakatech: async (id, status) => {
            return axios.patch(
                `${conf.GATEWAYAPI}/api/anakatech/free-spins/${encodeURIComponent(id)}/status`,
                { status }
            );
        },

        // ||||| ANAKATECH  SPORT BONUSES ||||

        createPlayerOpenBonus: async (clientCode, payload) => {
            return axios.post(`${conf.GATEWAYAPI}/api/anakatech/sport-bonus`, payload, { params: { clientCode } });
        },
        createPlayersOpenBonusBatchAnakatech: async (clientCode, payload) => {
            return axios.post(`${conf.GATEWAYAPI}/api/anakatech/sport-bonus/batch`, payload, { params: { clientCode } });
        },
        updateSportBonusConfigAnakatech: async (campaignId, payload) => {
            return axios.put(
                `${conf.GATEWAYAPI}/api/anakatech/sport-bonus/${encodeURIComponent(campaignId)}/config`,
                payload
            );
        },
        deactivateSportCampaignAnakatech: async (clientCode, campaignId) => {
            return axios.put(
                `${conf.GATEWAYAPI}/api/anakatech/sport-bonus/deactivate`,
                null,
                { params: { clientCode, campaignId } }
            );
        },
        getPlayerBonus: async (payload) => {
            return axios.get(`${conf.GATEWAYAPI}/api/anakatech/sport-bonus`, { params: payload });
        },
        cancelPlayerActiveBonus: async ({ playerId, providerId, campaignId, allBonuses, providerBonusId, clientCode }) => {
            const params = { playerId, providerId, campaignId, allBonuses, providerBonusId, clientCode };
            return axios.get(`${conf.GATEWAYAPI}/api/anakatech/sport-bonus/cancel`, { params });
        },
        getPlayerBonusOffers: async (payload) => { //maybe list campaigns from server
            return axios.get(`${conf.GATEWAYAPI}/api/anakatech/sport-bonus/offers-type`, { params: payload });
        },
        syncSportBonusAnakatech: async ({ providerId, sportBonusType, currency, client }) => {
            return axios.post(`${conf.GATEWAYAPI}/api/anakatech/sport-bonus/sync`, client,{ params: { providerId, sportBonusType, currency } });
        },
        // |||||      FIRST V2       ||||
        syncFirst2Campaigns: async (clientCode) => {
            return axios.post(`${conf.GATEWAYAPI}/api/first2/sync/campaigns`, { clientCode }, { headers: getHeaders() });
        },
        listFirst2Campaigns: async (params) => {
            return axios.get(`${conf.GATEWAYAPI}/api/first2/sync/campaigns`, { params, headers: getHeaders() });
        },
        assignFirst2Players: async (campaignId, payload) => {
            return axios.post(`${conf.GATEWAYAPI}/api/first2/sync/campaigns/${campaignId}/players`, payload, { headers: getHeaders() });
        },
        cancelFirst2Players: async (campaignId, payload) => {
            return axios.post(`${conf.GATEWAYAPI}/api/first2/sync/campaigns/${campaignId}/players/cancel`, payload, { headers: getHeaders() });
        },
        getFirst2BonusDetails: async (payload) => {
            return axios.post(`${conf.GATEWAYAPI}/api/first2/sync/bonus-details`, payload, { headers: getHeaders() });
        },
        updateFirst2CampaignConfig: async (campaignId, payload) => {
            return axios.put(`${conf.GATEWAYAPI}/api/first2/sync/campaigns/${campaignId}/config`, payload, { headers: getHeaders() });
        },
        clearFirst2CampaignConfig: async (campaignId) => {
            return axios.delete(`${conf.GATEWAYAPI}/api/first2/sync/campaigns/${campaignId}/config`, { headers: getHeaders() });
        },
        selectFirst2Campaign: async (campaignId) => {
            return axios.put(`${conf.GATEWAYAPI}/api/first2/sync/campaigns/${campaignId}/select`, {}, { headers: getHeaders() });
        },
        unselectFirst2Campaign: async (campaignId) => {
            return axios.delete(`${conf.GATEWAYAPI}/api/first2/sync/campaigns/${campaignId}/select`, { headers: getHeaders() });
        },
        getFirst2BonusDebit: async (bonusId, merchantCustomerCode, clientCode) => {
            return axios.get(`${conf.GATEWAYAPI}/api/first2/bonus-debit?bonusId=${bonusId}&merchantCustomerCode=${merchantCustomerCode}&page=1&take=20&skip=0&orderBy=id&orderDirection=DESC&siteId=20370&clientCode=${clientCode}`);
        },
        getFirst2BonusFree: async (bonusId, customerCode, clientCode) => {
            return axios.post(`${conf.GATEWAYAPI}/api/first2/bonus-free?bonusId=${bonusId}&customerCode=${customerCode}&clientCode=${clientCode}`);
        },

        //config bonus rules
        getAllRulesV2: async (params) => {
            const h = getHeaders();
            return axios.get(`${conf.GATEWAYAPI}/api/first2/admin/campaign-rules`, { params, headers: h });
        },
        createRuleV2: async (payload) => {
            const h = getHeaders();
            return axios.post(`${conf.GATEWAYAPI}/api/first2/admin/campaign-rules`, payload, { headers: h });
        },
        updateRuleV2: async (id, payload) => {
            const h = getHeaders();
            return axios.put(`${conf.GATEWAYAPI}/api/first2/admin/campaign-rules/${id}`, payload, { headers: h });
        },
        deleteRuleV2: async (id) => {
            const h = getHeaders();
            return axios.delete(`${conf.GATEWAYAPI}/api/first2/admin/campaign-rules/${id}`, { headers: h });
        }
    }

    const bonus = {
        list: async (params) => {
            headers.Authorization = sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.APIUSERS}/bonus/api/bonus/?${params}`, { headers })
        },
        save: async (payload) => {
            headers.Authorization = sessionStorage.getItem("token");
            return axios.post(`${conf.APIUSERS}/bonus/api/bonus`, payload, { headers });
        },
    }

    const trx = {
        list: async (params = '') => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.API}/trx/list?${params}`, { headers });
        },
        logs: async (params = '') => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.API}/trx/logs?${params}`, { headers });
        },
        paymentDirect: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.API}/trx/paymentDirect`, payload, { headers });
        },
    }

    const reports = {
        list: async (params = '') => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.API}/trx/summary?${params}`, { headers });
        }
    }

    const brands = {
        list: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.ADMI_BO}/brands?${params}`, { headers });
        },
        listBrandsByProvider: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.ADMI_BO}/games/brandsByProvider?${params}`, { headers });
        },
        listBrandsByCategory: async () => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.ADMI_BO}/games/brandsByCategory`, { headers });
        },
        saveBrand: async (params, formData) => {
            let brand = params.brand;
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            headers["Content-Type"] = "multipart/form-data";
            return axios.post(`${conf.API}/brands/uploadimage?brand=${brand}`, formData, { headers });
        }
    }

    const users = {
        list: async (params) => {
            const searchParams = new URLSearchParams(params);
            const searchValue = params.search?.trim() || params.searching?.trim();
            searchValue ? searchParams.set('search', searchValue) : searchParams.delete('search');
            const queryString = '?' + searchParams.toString();
            const headers = getHeaders();
            return axios.get(`${conf.ADMI_BO}/users/v2${queryString}`, { headers });
        }
    }

    return {
        login, client, trx, provider, games, gamers, brands, freespin, adminusers, reports, bonus, work, users
    }

})()
export default serverConnection
